const ENDPOINT = 'GETpendingSongsRequests';
var ChangeRequestsStatus;
(function (ChangeRequestsStatus) {
    ChangeRequestsStatus["all"] = "all";
    ChangeRequestsStatus[ChangeRequestsStatus["pending"] = 0] = "pending";
    ChangeRequestsStatus[ChangeRequestsStatus["approved"] = 1] = "approved";
    ChangeRequestsStatus[ChangeRequestsStatus["rejected"] = 2] = "rejected";
})(ChangeRequestsStatus || (ChangeRequestsStatus = {}));
var ChangeRequestsFilters;
(function (ChangeRequestsFilters) {
    ChangeRequestsFilters["other"] = "other";
    ChangeRequestsFilters["approved"] = "approved";
    ChangeRequestsFilters["rejected"] = "rejected";
    ChangeRequestsFilters["ignored"] = "ignored";
})(ChangeRequestsFilters || (ChangeRequestsFilters = {}));
function getPendingSongsRequests(gateway, params) {
    if (!params)
        return null;
    return gateway.get(getPendingSongsRequests.endpoint, params);
}
getPendingSongsRequests.endpoint = ENDPOINT;

export { ChangeRequestsFilters, ChangeRequestsStatus, getPendingSongsRequests as default };
//# sourceMappingURL=getPendingSongsRequests.js.map
